import React from 'react';

const FullScreenLoader = () => {
  return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="h-10 w-10 border-2 border-primaryAccent border-t-transparent rounded-full animate-spin"></div>
    </div>
  );
};

export default FullScreenLoader;